<template>
	<div class="table-item-product-box">
		<img class="table-item-product-box__thumbnail" :src="src" />
		<button
			class="table-item-product-box__name"
			type="button"
			@click="click"
		>
			{{ name }}
		</button>
	</div>
</template>

<script>
	export default {
		name: 'TableItemProductBox',
		props: {
			src: {
				type: String,
				default: '',
			},
			name: {
				type: String,
				default: '',
			},
		},
		methods: {
			click() {
				this.$emit('click');
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.table-item-product-box {
		.table-item-product-box__thumbnail {
			float: left;
			display: block;
			width: 50px;
			height: 50px;
		}

		.table-item-product-box__name {
			overflow: hidden;
			display: block;
			padding-left: 8px;
			line-height: 16px;
			text-align: left;
			white-space: normal;
			word-wrap: break-word;
			word-break: break-all;
		}
	}
</style>
